<template>
    <span/>
</template>

<script>
//overlays for single line mouseover or click display of transcriptions
const { addSingleLineTranscripts } = require("../../helpers/single-line-transcript");
const { mapState } = require("vuex");

export default {
    name: "single-line-transcript",
    props: ["svgNode", "transcriptHook"],

    computed: {
        ...mapState("transcript", ["eventBus", "opacity"])
    },

    mounted() {
        this.eventBus.$on('overlay-opacity-change', () => {
            toggleVisibility(this.opacity)
        })
        this.eventBus.$on('text-adjust', () => {
            if(this.svgNode && this.transcriptHook()) {
                initLineTranscripts(this.transcriptHook(), this.svgNode())
            }
        })
    }

}

function initLineTranscripts(transcript, svgNode) {
    console.log("initializing line transcripts");
    if (transcript && svgNode) {
        addSingleLineTranscripts(transcript, svgNode);
    }
}

function toggleVisibility(opacity) {
    // only display single-line transcript tooltips if opacity is below threshold value
    document.querySelectorAll(".tool-tip-overlay").forEach((el) => {
        if(opacity > 75) {
            el.style.display = "none";
        }
        else {
            el.style.display = "block";
        }
    });
}
</script>